import "regenerator-runtime/runtime";
import { all, fork } from "redux-saga/effects";
import searchProvidersSaga from "./providerSaga";
import * as ssoSaga from "./ssoSaga";
import headerSaga from "./headerSaga";
import dashboardSaga from "./dashboardSaga";
import todosSaga from "./todosSaga";
import pharmacySaga from "./pharmacySaga";
import pharmacyProxySaga from "./pharmacyProxySaga";
import healthPlanSaga from "./healthPlanSaga";
import healthSourceSaga from "./healthSourceSaga";
import membershipsSaga from "./membershipsSaga";
import errorSaga from "./errorSaga";
import searchLocationsSaga from "./locationSaga";
import openSchedulingSaga from "./openSchedulingSaga";
import docsSaga from "./docsSaga";
import commonSaga from "./commonSaga";
import directSchedulingSaga from "./directSchedulingSaga";
import profileToolsSaga from "./ProfileToolsSaga";
import portalSaga from "./PortalSaga";
import thriveSaga from "./thriveSaga";
import healthPlanServicesSaga from "./healthPlanServicesSaga";
import mychartProxySaga from "./mychartProxySaga";
import epicSaga from "./epicSaga";
import proxySaga from './proxySaga';
import videoVisitSchedulingSaga from './videoVisitSchedulingSaga';
//import dcjInboxSaga from "./dcjInboxSaga";
import pricingSaga from "./pricingSaga";
import myChartDataTileSaga from "./myChartDataTileSaga";
import marketingEmailOptInSaga from "./marketingEmailOptInSaga";
import prayerFeatureSaga from "./prayerFeatureSaga";
import inHomeSaga from "./inHomeSaga";
import careGapsSaga from './careGapsSaga';

// register watcher saga(s) and export a single generator function as the root saga.
export default function* startForeman() {
    let bundle = "mybswhealth";

    if (typeof window !== 'undefined') {
        bundle = window.serverData.data.bundle;
    }

    // sagas needed by all bundles
    let watchers = [
        fork(searchProvidersSaga),
        fork(searchLocationsSaga),
        fork(ssoSaga.watchUserAuthenticate),
        fork(headerSaga),
        fork(pharmacySaga),
        fork(pharmacyProxySaga),
        fork(membershipsSaga),
        fork(errorSaga),
        fork(openSchedulingSaga),
        fork(docsSaga),
        fork(commonSaga),
        fork(directSchedulingSaga),
        fork(profileToolsSaga),
        fork(portalSaga),
        fork(thriveSaga),
        fork(healthPlanServicesSaga),     
        fork(mychartProxySaga),
        fork(dashboardSaga),
        fork(todosSaga),
        fork(healthPlanSaga),
        fork(healthSourceSaga),
        fork(epicSaga),
        fork(proxySaga),
        fork(videoVisitSchedulingSaga),
        //fork(dcjInboxSaga),
        fork(pricingSaga),
        fork(myChartDataTileSaga),
        fork(marketingEmailOptInSaga),
        fork(prayerFeatureSaga),
        fork(inHomeSaga),
        fork(careGapsSaga)
    ];

    // nice idea, but it sure made Salah's day harder...
    /*
     // sagas needed by the portal
    if (bundle === "mybswhealth") {
        watchers.push(fork(dashboardSaga));
        watchers.push(fork(todosSaga));
        watchers.push(fork(healthPlanSaga));
        watchers.push(fork(healthSourceSaga));
    }
    */

    try {
        yield all(watchers);
    }
    catch (err) {
        //debugger;
        console.error(err);
    }
}